module.exports = __webpack_public_path__ + "static/media/virrey.44aabb8e.jpg";